import React, { useState, useRef } from 'react';
import { paymentsService } from '../services/api';
import { convertToEnglishDigits } from '../utils/phoneUtils';

const DAYS = [
  {
    day: 'روز اول',
    title: 'خروج از انکار',
    desc: 'در روز اول به بایگانی حافظه دوران کودکی سفر می‌کنیم. شما با مکانیزم‌های دفاعی ذهن روبه‌رو می‌شوید. این زمان بیداری است تا بفهمید چرا ناخودآگاه مانع شماست و چگونه رنج‌های گذشته را در بدن ذخیره کرده‌اید تا بند ناف وابستگی‌های سمی قطع شود.',
    image: '/workshop-gallery/g2.jpg',
  },
  {
    day: 'روز دوم',
    title: 'تولد دوباره',
    desc: 'روز دوم زمان رهاسازی و بازپس‌گیری قدرت است. با تکنیک‌های فوق‌قدرتمند، زنجیرهای کینه را پاره می‌کنید. در این مرحله طلای دزدیده‌شده خود را پس می‌گیرید و همچون ققنوس از میان خاکستر دردهای گذشته برمی‌خیزید و آشتی عمیقی با خود واقعی‌تان تجربه می‌کنید.',
    image: '/workshop-gallery/g10.jpg',
  },
  {
    day: 'روزهای ۳ تا ۵',
    title: 'تثبیت',
    desc: 'تحول شما در سالن همایش تمام نمی‌شود. در وبینارهای اختصاصی پس از کارگاه، ناخودآگاه شما را برای آینده‌ای نوین بازطراحی می‌کنیم. شما یاد می‌گیرید در مواجهه با بحران‌های جدید، سریعاً خود را ترمیم کرده و مسیر پیشرفت را با قدرت و استقامت ادامه دهید.',
    image: '/workshop-gallery/g18.jpg',
  },
];

const FAQS = [
  { q: 'آیا این دوره برای ذهن‌های کاملاً منطقی هم جواب می‌دهد؟', a: 'بله، این متد بر پایه نوروساینس و روانکاوی یونگ طراحی شده و نتایج آن برای منطقی‌ترین افراد نیز کاملاً ملموس است.' },
  { q: 'آیا شخم زدن گذشته باعث بدتر شدن حال من نمی‌شود؟', a: 'زخم روانی تا زمانی که باز و پاکسازی نشود، از درون عفونت می‌کند. ما اینجا آن را برای همیشه درمان می‌کنیم.' },
  { q: 'آیا مبلغ سرمایه‌گذاری برای این دوره توجیه اقتصادی دارد؟', a: 'این هزینه، سرمایه‌گذاری قطعی شما برای جلوگیری از ده‌ها میلیون تومان ضرر ناشی از تصمیمات اشتباه در آینده زندگی‌تان است.' },
  { q: 'آیا این کارگاه می‌تواند بیماری‌های جسمی را درمان کند؟', a: 'بسیاری از دردهای روان‌تنی (سایکوسوماتیک) با تخلیه خشم و کینه‌های رسوب‌کرده در ناخودآگاه، بهبودی بسیار چشمگیر و پایداری می‌یابند.' },
  { q: 'آیا برای ترک اعتیادهای سنگین می‌توان روی این دوره حساب کرد؟', a: 'بله، با ریشه‌یابی دقیق اضطراب‌ها و تله‌های روانی، نیاز به مصرف هرگونه مواد مخدر از سطح ناخودآگاه شما پاک می‌شود.' },
  { q: 'تفاوت این کارگاه با جلسات مشاوره روانشناسی در چیست؟', a: 'اینجا به جای تئوری‌های طولانی، با استفاده از تکنیک‌های عملی و جراحی عمیق ذهن، ریشه مشکلات شما مستقیماً خشکانده می‌شود.' },
  { q: 'آیا در این کارگاه روی افزایش درآمد و ثروت هم کار می‌شود؟', a: 'با رفع تله‌های فقر و احساس بی‌ارزشی در ناخودآگاه، مسیر عصبی مغز شما برای خلق ثروت‌های پایدار کاملاً بازسازی می‌گردد.' },
  { q: 'آیا می‌توانم همسر یا شریک عاطفی‌ام را به زور به کارگاه بیاورم؟', a: 'خیر، مسیر شفا یک فرایند کاملاً فردی است و هر شخص باید با اراده آزاد و خواست قلبی خودش حاضر شود.' },
  { q: 'آیا این دوره برای رهایی از افسردگی‌های مزمن تأثیرگذار است؟', a: 'با کشف معنای رنج‌ها و بازپس‌گیری شور زندگی، ریشه‌های اصلی بی‌انگیزگی و افسردگی‌های عمیق به طور کامل از بین می‌روند.' },
  { q: 'آیا تکنیک نامه‌نگاری واقعاً کینه‌های قدیمی را پاک می‌کند؟', a: 'بله، این پروتکل قدرتمند عصبی با تغییر زاویه دید ذهن، خشم شما را تخلیه کرده و منجر به بخشش واقعی می‌شود.' },
  { q: 'آیا تکنیک آینه به تنهایی می‌تواند عزت نفس را برگرداند؟', a: 'این رویارویی مستقیم و بدون نقاب با خود، دیوارهای شرم را شکسته و عشق و ارزشمندی درونی را مجدداً بیدار می‌کند.' },
  { q: 'تکنیک پنج چرا (5 Whys) چه کمکی به من می‌کند؟', a: 'این روش علمی به شما کمک می‌کند تا از لایه‌های سطحی استرس عبور کرده و به هسته مرکزی اضطراب‌هایتان دسترسی یابید.' },
  { q: 'مهندسی معکوس تروما در این کارگاه به چه معناست؟', a: 'ما به شما می‌آموزیم که چگونه ذهن شما از بیماری یا فقر منفعت می‌برد تا این چرخه معیوب را متوقف کنید.' },
  { q: 'آیا این دوره فقط برای افراد آسیب‌دیده و بحران‌زده است؟', a: 'خیر، حتی افراد موفق نیز برای عبور از سقف درآمدی و رسیدن به آرامش و تکامل بیشتر به این آگاهی‌ها نیازمندند.' },
  { q: 'منظور از عقده پدری و مادری در این آموزش‌ها چیست؟', a: 'شما متوجه می‌شوید که چگونه تله‌های وابستگی و مهرطلبی، از ارتباطات دوران کودکی شما نشأت گرفته و امروزتان را تخریب می‌کنند.' },
  { q: 'شب خرابات در این کارگاه چه کاربردی دارد؟', a: 'یک شب خلوت و سیر و سلوک معنوی در سکوت مطلق است تا فرد به دور از هیاهو، با روح خود ارتباط بگیرد.' },
  { q: 'آیا می‌توانم با فرزند نوجوانم در این دوره شرکت کنم؟', a: 'بله، درک این مفاهیم در سنین نوجوانی، از شکل‌گیری تروماهای آینده جلوگیری کرده و مسیر موفقیت آن‌ها را تضمین می‌کند.' },
  { q: 'چگونه می‌توانم مطمئن باشم نتایج این کارگاه ماندگار است؟', a: 'شما در وبینارهای تکمیلی پس از دوره حضوری، ابزارهایی دریافت می‌کنید که این تغییرات را به صورت مادام‌العمر در ذهنتان تثبیت می‌کند.' },
  { q: 'آیا این آموزش‌ها با عقاید مذهبی من در تضاد است؟', a: 'به هیچ وجه؛ این متدولوژی با بهره‌گیری از عرفان اصیل و اشعار بزرگان، ارتباط معنوی شما با خالق را بسیار عمیق‌تر می‌سازد.' },
  { q: 'تکنیک بالن یا رهاسازی چه مشکلی را حل می‌کند؟', a: 'این تمرین ذهنی به صورت نمادین بند ناف وابستگی‌های سمی شما به افراد و نتایج را قطع کرده و رهایی می‌بخشد.' },
  { q: 'آیا ممکن است با شخم زدن گذشته، خانواده‌ام را مقصر بدانم؟', a: 'هدف ما یافتن مقصر نیست؛ بلکه پذیرش آگاهانه گذشته و تغییر واکنش‌های شما برای ساختن یک زندگی سالم و مستقل است.' },
  { q: 'چرا راحت‌طلبی به عنوان بزرگترین اعتیاد انسان معرفی می‌شود؟', a: 'زیرا ذهن برای حفظ امنیت کاذب، شما را در دایره رنج‌های تکراری نگه می‌دارد و مانع هرگونه رشد و تغییر واقعی می‌شود.' },
  { q: 'آیا تغییر سناریوی گذشته واقعاً امکان‌پذیر است؟', a: 'شما نمی‌توانید رویداد را حذف کنید، اما با تغییر مسیرهای عصبی در ناخودآگاه، زهر و اثر مخرب آن خاطره را خنثی می‌کنید.' },
  { q: 'بازپس‌گیری طلا در انتهای کارگاه به چه معناست؟', a: 'شما در این مرحله قدرت، استعداد و شجاعتی را که در گذشته با قضاوت دیگران از شما سرقت شده بود، بازپس می‌گیرید.' },
  { q: 'من سال‌ها تراپی رفته‌ام، این دوره چه تفاوت جدیدی دارد؟', a: 'این کارگاه به جای تحلیل سطحی، مستقیماً وارد لایه‌های عمیق ناخودآگاه جمعی و فردی شده و تغییرات کوانتومی ایجاد می‌کند.' },
  { q: 'آیا این دوره می‌تواند جلوی طلاق و فروپاشی خانواده را بگیرد؟', a: 'با درمان گره‌های روانی و خشم‌های پنهان هر دو طرف، هزاران رابطه در شرف فروپاشی مجدداً با عشق و درک متقابل بازسازی شده‌اند.' },
  { q: 'آیا برای شرکت در این کلاس به پیش‌نیاز علمی خاصی نیاز دارم؟', a: 'خیر، مطالب با وجود عمق علمی بالا، با زبانی کاملاً ساده، کاربردی و همه‌فهم توسط استاد قورچیان تدریس و تمرین می‌شوند.' },
  { q: 'آیا در این کارگاه روش‌های قانون جذب آموزش داده می‌شود؟', a: 'ما به جای قانون جذب سطحی، روی ارتعاشات واقعی ناخودآگاه و تبدیل شدن به پادشاه سرزمین عمل‌گرایی و تلاش کار می‌کنیم.' },
  { q: 'اگر نتوانم در هنگام تمرینات گریه کنم یا فریاد بزنم چه؟', a: 'هر فرد واکنش روانی منحصر به فرد خود را دارد؛ حضور و همسویی ذهنی شما با جریان کلاس، برای پاکسازی ناخودآگاه کفایت می‌کند.' },
  { q: 'آیا این متد برای درمان وسواس‌های فکری و عملی کاربرد دارد؟', a: 'بله، با شناسایی ریشه اضطراب‌ها و تله کنترل‌گری، شدت وسواس‌های فکری به سرعت در ساختار روان شما کاهش چشمگیری می‌یابد.' },
  { q: 'آیا این کارگاه می‌تواند ترس از شکست را در من از بین ببرد؟', a: 'با خروج از تله کمال‌گرایی و پذیرش آسیب‌پذیری انسان، شجاعت اقدام کردن و عبور از ترس‌ها در وجود شما نهادینه می‌شود.' },
  { q: 'منظور از قانون جهش کوانتومی روان در این کلاس چیست؟', a: 'با انجام راهکارهایی برخلاف عادت‌های همیشگی، شما در مدت زمان بسیار کوتاهی به تغییراتی معادل سال‌ها تلاش دست پیدا خواهید کرد.' },
  { q: 'آیا این دوره برای مدیران و صاحبان کسب‌وکار نیز مفید است؟', a: 'قطعاً، با رفع سایه‌های درونی و تضادهای ذهنی، قدرت رهبری، تصمیم‌گیری و توانایی تیم‌سازی شما به شکل حیرت‌انگیزی افزایش می‌یابد.' },
  { q: 'چگونه از مقاومت‌های ذهنی خودم در طول دوره عبور کنم؟', a: 'ساختار کلاس به گونه‌ای طراحی شده که پله‌پله و با همراهی پشتیبانان، مقاومت‌های ناخودآگاه شما به صورت کاملاً علمی شکسته می‌شود.' },
  { q: 'آیا با شرکت در این دوره، دوستان و اطرافیانم را از دست می‌دهم؟', a: 'شما تنها از روابط سمی و وابستگی‌های آسیب‌زا رها می‌شوید و در مدار جذب انسان‌های هم‌فرکانس، سالم و حمایتگر قرار می‌گیرید.' },
  { q: 'منظور از سندرم عقده یونس در آموزش‌های شما چیست؟', a: 'این سندرم به ترس پنهان انسان از موفقیت‌های عظیم و فرار از پذیرش رسالت‌های بزرگ زندگی اشاره دارد که اینجا درمان می‌شود.' },
  { q: 'آیا امکان ارتباط مستقیم با شخص استاد در طول دوره وجود دارد؟', a: 'در روزهای حضوری و وبینارهای تخصصی، ایشان بر روند کلی کلاس نظارت دقیق دارند و به سوالات کلیدی و چالش‌برانگیز پاسخ می‌دهند.' },
  { q: 'من فردی به شدت خجالتی هستم، آیا در این کارگاه معذب می‌شوم؟', a: 'فضای کارگاه سرشار از امنیت روانی و پذیرش بدون قضاوت است؛ شما در کمال آرامش، حصارهای خجالت و شرم را خواهید شکست.' },
  { q: 'آیا این کارگاه راهکاری برای خروج از منطقه امن ارائه می‌دهد؟', a: 'بله، با شناخت اعتیاد مغز به راحت‌طلبی، ما شما را به صورت کاملاً کنترل‌شده برای رویارویی با ناشناخته‌ها و رشد آماده می‌کنیم.' },
  { q: 'منظور از شفای کودک درون در مباحث این کارگاه چیست؟', a: 'ما به دوران صفر تا ده‌سالگی بازمی‌گردیم تا زخم‌ها، حسرت‌ها و ترس‌های کودکی را که زندگی امروزتان را کنترل می‌کنند، التیام بخشیم.' },
  { q: 'آیا با نوشتن نامه خشم، روابط من با خانواده‌ام خراب نمی‌شود؟', a: 'این نامه‌ها هرگز به دست افراد نمی‌رسد؛ این تنها یک ابزار سایکولوژیک برای تخلیه بار منفی روان و رسیدن به صلح درونی است.' },
  { q: 'آیا پس از پایان کارگاه به حال و روز گذشته‌ام برنمی‌گردم؟', a: 'با انجام تمرینات مداوم ۴۰ روزه و استفاده از ابزارهای پشتیبانی موسسه، مسیرهای عصبی جدید شما برای همیشه تثبیت خواهند شد.' },
  { q: 'چرا باید قبل از تغییر، از منِ فعلی‌ام متنفر شوم؟', a: 'طبق قانون ققنوس، تا زمانی که از دردهای تکراری و شخصیت ضعیف گذشته خود خسته نشوید، انگیزه کافی برای تولدی دوباره نخواهید داشت.' },
  { q: 'جدول رنجش‌ها و کشف سایه‌ها چه کمکی به رشد من می‌کند؟', a: 'شما درمی‌یابید ویژگی‌هایی که در دیگران شما را آزار می‌دهند، در واقع انعکاس بخش‌های تاریک و سرکوب‌شده‌ی روان خودتان هستند.' },
  { q: 'آیا این دوره برای افرادی که مدام خیانت می‌بینند راهگشاست؟', a: 'با درمان احساس بی‌ارزشی و تله طردشدگی در ناخودآگاه، زنجیره تکرار الگوهای سمی و جذب آدم‌های اشتباه برای همیشه پاره می‌شود.' },
  { q: 'آیا افراد مسن (بالای ۶۰ سال) هم از این کارگاه نتیجه می‌گیرند؟', a: 'شفا سن و سال نمی‌شناسد؛ ما شرکت‌کنندگان بسیاری داشته‌ایم که در دهه‌های ششم و هفتم زندگی خود به آرامش و رهایی بی‌نظیری دست یافته‌اند.' },
  { q: 'مفهوم قربانگاه در وبینارهای پس از کارگاه به چه معناست؟', a: 'شما یاد می‌گیرید برای رسیدن به اهداف بزرگ، چگونه لذت‌های زودگذر، تنبلی‌ها و بهانه‌های کوچک خود را آگاهانه قربانی کنید.' },
  { q: 'آیا این متدولوژی فقط مختص جامعه ایران طراحی شده است؟', a: 'این اصول بر پایه ساختار جهانی روان انسان تدوین شده، اما کاملاً با ناخودآگاه جمعی، فرهنگ و چالش‌های جامعه ایرانی بومی‌سازی شده است.' },
  { q: 'آیا می‌توانم بدون حضور در سالن، فقط ویدیوهای دوره را ببینم؟', a: 'انرژی جمعی، همسویی با استاد و قرار گرفتن در اتمسفر سالن، بخش بسیار حیاتی از فرایند جراحی ناخودآگاه و جهش روانی شماست.' },
  { q: 'در صورت داشتن افت تحصیلی یا شغلی، این کلاس چه کمکی می‌کند؟', a: 'با بازیابی استعدادهای سرکوب‌شده و دریافت نقشه راه عمل‌گرایی، شما انگیزه و قدرت لازم برای خلق یک مسیر جدید را پیدا می‌کنید.' },
];

interface VideoItem { title: string; caption: string; cover: string; src: string; aparat: string; }
const VIDEOS: VideoItem[] = [
  { title: 'از پول خشم داشتم', caption: 'از پول خشم داشتم', cover: '/workshop-gallery/g1.jpg', src: '', aparat: '' },
  { title: 'وارد مسیر ثروت‌سازی شدم', caption: 'وارد مسیر ثروت‌سازی شدم', cover: '/workshop-gallery/g4.jpg', src: '', aparat: '' },
  { title: 'درآمدم ۳ برابر شد', caption: 'درآمدم ۳ برابر شد', cover: '/workshop-gallery/g6.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', aparat: '' },
  { title: 'بیزینس شخصیم را شکل دادم', caption: 'بیزینس شخصیم رو راه انداختم و برند خودم رو دارم', cover: '/workshop-gallery/g8.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4', aparat: '' },
  { title: 'ترسم از آینده از بین رفت', caption: 'ترسم از آینده از بین رفت', cover: '/workshop-gallery/g12.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4', aparat: '' },
  { title: 'روابطم متحول شد', caption: 'روابطم متحول شد', cover: '/workshop-gallery/g14.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', aparat: '' },
  { title: 'از زخم‌هایم رها شدم', caption: 'از زخم‌هایم رها شدم', cover: '/workshop-gallery/g16.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4', aparat: '' },
  { title: 'خودم رو دوباره پیدا کردم', caption: 'خودم رو دوباره پیدا کردم', cover: '/workshop-gallery/g19.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4', aparat: '' },
  { title: 'اعتماد به نفسم برگشت', caption: 'اعتماد به نفسم برگشت', cover: '/workshop-gallery/g21.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', aparat: '' },
  { title: 'مسیر شادی رو پیدا کردم', caption: 'مسیر شادی رو پیدا کردم', cover: '/workshop-gallery/g23.jpg', src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4', aparat: '' },
];

export default function WorkshopShefayeZakhm() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [faqPage, setFaqPage] = useState(0);
  const FAQ_PER_PAGE = 5;
  const faqTotalPages = Math.ceil(FAQS.length / FAQ_PER_PAGE);
  const faqVisible = FAQS.slice(faqPage * FAQ_PER_PAGE, (faqPage + 1) * FAQ_PER_PAGE);
  const [hoveredDay, setHoveredDay] = useState<number | null>(null);
  const [hoveredVideo, setHoveredVideo] = useState<number | null>(null);
  const [playingVideo, setPlayingVideo] = useState<number | null>(null);
  const [whyVideoPlaying, setWhyVideoPlaying] = useState(false);
  const [ctaVideoPlaying, setCtaVideoPlaying] = useState(false);
  const [lightbox, setLightbox] = useState<number | null>(null);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [registerForm, setRegisterForm] = useState({ customerName: '', customerMobile: '' });
  const [registerSubmitting, setRegisterSubmitting] = useState(false);
  const [registerError, setRegisterError] = useState('');

  const handleRegisterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setRegisterError('');

    const name = registerForm.customerName.trim();
    const mobile = convertToEnglishDigits(registerForm.customerMobile).replace(/[^\d]/g, '');

    if (!name || /[0-9]/.test(name)) {
      setRegisterError('نام و نام خانوادگی را بدون عدد وارد کنید');
      return;
    }
    if (!/^09[0-9]{9}$/.test(mobile)) {
      setRegisterError('شماره موبایل را درست وارد کنید (مثال: 09121234567)');
      return;
    }

    setRegisterSubmitting(true);
    try {
      const { paymentUrl } = await paymentsService.registerShefayeZakhmWorkshop({
        customerName: name,
        customerMobile: mobile,
      });
      window.location.href = paymentUrl;
    } catch (err: any) {
      setRegisterError(
        err?.response?.data?.message || 'خطا در اتصال به درگاه پرداخت. لطفاً دوباره تلاش کنید یا با ما تماس بگیرید.'
      );
      setRegisterSubmitting(false);
    }
  };

  const marqueeRef = useRef<HTMLDivElement>(null);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const videoScrollRef = useRef<HTMLDivElement>(null);
  const dragRef = useRef({ active: false, startX: 0, startPos: 0, moved: false });
  const MARQUEE_DURATION = 55;

  const getMarqueeX = (): number => {
    const el = marqueeRef.current;
    if (!el) return 0;
    const t = window.getComputedStyle(el).transform;
    if (!t || t === 'none') return 0;
    return new DOMMatrix(t).m41;
  };

  const handleMarqueeMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    const el = marqueeRef.current;
    if (!el) return;
    const setW = el.scrollWidth / 2;
    const pos = getMarqueeX();
    dragRef.current = { active: true, startX: e.clientX, startPos: pos, moved: false };
    el.style.animationPlayState = 'paused';
    el.style.transform = `translateX(${pos}px)`;
    document.body.style.cursor = 'grabbing';

    const onMove = (ev: MouseEvent) => {
      const delta = ev.clientX - dragRef.current.startX;
      if (Math.abs(delta) > 5) dragRef.current.moved = true;
      let p = dragRef.current.startPos + delta;
      p = ((p % setW) - setW) % setW;
      el.style.transform = `translateX(${p}px)`;
    };

    const onUp = () => {
      dragRef.current.active = false;
      document.body.style.cursor = '';
      const cur = getMarqueeX();
      const norm = ((cur % setW) - setW) % setW;
      const delay = -((Math.abs(norm) / setW) * MARQUEE_DURATION);
      el.style.transform = '';
      el.style.animation = 'none';
      void el.offsetHeight;
      el.style.animation = `workshopMarquee ${MARQUEE_DURATION}s ${delay}s linear infinite`;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  return (
    <div dir="rtl" className="workshop-page text-gray-900 overflow-x-hidden">
      <style>{`
        .workshop-page p { font-weight: 700; }
        .workshop-page h1, .workshop-page h2, .workshop-page h3, .workshop-page h4 { font-weight: 900; }
        @media (max-width: 1023px) {
          .faraz-section { aspect-ratio: 4/3 !important; }
          .zakhm-cta-section { aspect-ratio: 16/9 !important; }
        }
        @media (max-width: 639px) {
          .faraz-section { aspect-ratio: 3/4 !important; }
          .zakhm-cta-section { aspect-ratio: 4/3 !important; }
        }
      `}</style>

      {/* Hero */}
      <section className="bg-gray-50 pb-4 pt-4">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <nav className="flex items-center gap-1.5 text-sm text-gray-500 mb-4" dir="rtl">
            <a href="/" className="hover:text-gray-800 transition">خانه</a>
            <span className="text-gray-300">/</span>
            <a href="/workshops" className="hover:text-gray-800 transition">دوره‌ها</a>
            <span className="text-gray-300">/</span>
            <span className="text-gray-800 font-medium">کارگاه شفای زخم ۸۰</span>
          </nav>
          <div className="relative rounded-xl overflow-hidden w-full">
            {/* دسکتاپ */}
            <img
              src="/workshop-hero-desktop.png"
              alt="هشتادمین کارگاه شفای زخم - استاد فراز قورچیان"
              className="w-full hidden lg:block"
            />
            {/* موبایل */}
            <img
              src="/workshop-hero.png"
              alt="هشتادمین کارگاه شفای زخم - استاد فراز قورچیان"
              className="w-full lg:hidden"
            />

            {/* سایه برای خوانا شدن متن روی تصویر */}
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-l from-black/55 via-black/20 to-transparent" />

            {/* متن روی تصویر */}
            <div
              dir="rtl"
              className="absolute inset-0 flex flex-col items-start justify-center text-right px-4 sm:px-8 lg:px-14 pb-0 sm:pb-14 lg:pb-16"
            >
              <p className="text-white/85 font-medium leading-none text-[11px] sm:text-lg lg:text-2xl">
                هشتادمین
              </p>
              <h1 className="mt-1 sm:mt-2 font-black text-white leading-tight text-lg sm:text-3xl lg:text-5xl">
                کارگاه شفای زخم
              </h1>
              <p className="mt-1 sm:mt-3 text-white/80 leading-none text-[10px] sm:text-base lg:text-xl">
                استاد فراز قورچیان
              </p>
              <a
                href="#register"
                className="mt-2 sm:mt-5 inline-flex items-center rounded-lg bg-white text-[#2b1b0e] font-extrabold shadow-lg transition hover:bg-white/90 px-3 py-1.5 text-[11px] sm:px-6 sm:py-2.5 sm:text-base lg:px-8 lg:py-3 lg:text-lg"
              >
                همین حالا ثبت‌نام کنید
              </a>

              {/* اطلاعات کارگاه — فقط از تبلت به بالا */}
              <div className="absolute bottom-4 lg:bottom-6 left-8 lg:left-14 hidden sm:flex items-center divide-x divide-x-reverse divide-white/25">
                {[
                  { label: 'شروع کارگاه', value: '۱ تا ۶ شهریور' },
                  { label: 'مدت کارگاه', value: '۳۵ ساعت' },
                  { label: 'نحوه برگزاری', value: 'حضوری و آنلاین' },
                ].map((item) => (
                  <div key={item.label} className="px-4 lg:px-5 text-center">
                    <p className="font-bold text-white leading-none text-xs lg:text-base">{item.label}</p>
                    <p className="mt-1.5 text-white/75 leading-none text-[11px] lg:text-sm">{item.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Card: چرا + هر آنچه */}
      <section className="pt-4 pb-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <div className="bg-white rounded-xl p-6 lg:p-8">

            {/* ویدیو راست، متن چپ */}
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              {/* ویدیو — اول در DOM = سمت راست در RTL */}
              <div className="rounded-xl overflow-hidden aspect-video relative cursor-pointer group" onClick={() => setWhyVideoPlaying(true)}>
                {whyVideoPlaying ? (
                  <>
                    <iframe
                      src="https://www.aparat.com/video/video/embed/videohash/gdp3808/vt/frame?autoplay=1"
                      className="absolute inset-0 w-full h-full border-0"
                      allowFullScreen
                      allow="autoplay; fullscreen"
                    />
                    <button
                      className="absolute top-2 right-2 z-20 w-7 h-7 rounded-full bg-black/60 text-white text-xs flex items-center justify-center hover:bg-black/80 transition"
                      onClick={(e) => { e.stopPropagation(); setWhyVideoPlaying(false); }}
                    >✕</button>
                  </>
                ) : (
                  <>
                    <img src="/workshop-video-cover2.png" alt="ویدیو کارگاه شفای زخم" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-300" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 group-hover:bg-black/55 transition-all duration-300">
                        <svg className="w-5 h-5 text-white translate-x-0.5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/* متن — دوم در DOM = سمت چپ در RTL */}
              <div className="text-right">
                <h2 className="mb-4 text-gray-900 leading-snug" style={{ fontSize: '1.7rem', fontWeight: 1000 }}>چرا کارگاه شفای زخم؟</h2>
                <p className="font-medium leading-7 text-[#474747]" style={{ fontSize: '1rem' }}>
                  بسیاری از ما در تله‌های تکراری زندگی گیر کرده‌ایم؛ از شکست‌های مالی پی‌درپی تا روابط سمی که پایان نمی‌یابند. کارگاه شفای زخم به شما می‌آموزد که این رنج‌ها تصادفی نیستند، بلکه بازتاب زخم‌های شفا نیافته‌ای هستند که در ناخودآگاه رسوب کرده‌اند. ما اینجا ریشه‌ها را جراحی می‌کنیم تا میوه‌های زندگی شما کاملاً تغییر کند.
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-3 pt-6 border-t border-gray-100">
              {[
                {
                  label: 'تعداد برگزاری', value: '۸۰',
                  icon: (<img src="/workshop-stat-edition.png" alt="" />),
                },
                {
                  label: 'زمان کارگاه', value: '۱ تا ۶ شهریور',
                  icon: (<img src="/workshop-stat-date.png" alt="" />),
                },
                {
                  label: 'مدت کارگاه', value: '۳۵ ساعت',
                  icon: (<img src="/workshop-stat-duration.png" alt="" />),
                },
                {
                  label: 'نحوه برگزاری', value: 'حضوری و آنلاین',
                  icon: (<img src="/workshop-stat-mode.png" alt="" />),
                },
              ].map((s) => (
                <div key={s.label} className="flex flex-row items-center gap-3 p-4">
                  {/* آیکون — اول در DOM = سمت راست در RTL */}
                  <div className="shrink-0 w-16 h-16 flex items-center justify-center [&>img]:w-16 [&>img]:h-16 [&>img]:object-contain">
                    {s.icon}
                  </div>
                  {/* متن — دوم در DOM = سمت چپ در RTL */}
                  <div className="flex flex-col text-right min-w-0">
                    <p className="font-extrabold leading-tight text-[#474747]" style={{ fontSize: '1.2rem' }}>{s.label}</p>
                    <p className="text-[#717171]" style={{ fontSize: '1rem', marginTop: '5px' }}>{s.value}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* هر آنچه برای تغییر پایدار نیاز دارید */}
            <div className="mt-8 pt-8 border-t border-gray-100">
              <h2 className="font-black text-center mb-6 text-gray-900" style={{ fontSize: '1.7rem' }}>
                هر آنچه برای تغییر پایدار نیاز دارید
              </h2>
              <div className="grid md:grid-cols-3 gap-4">
                {[
                  {
                    title: 'کالبدشکافی ناخودآگاه',
                    desc: 'در این مرحله سدهای دفاعی ذهن را می‌شکنیم. شما با تاریک‌ترین بخش‌های روان خود روبه‌رو می‌شوید تا ریشه ترس‌ها، اضطراب‌ها و تله‌های کودکی را شناسایی و برای همیشه خنثی کنید.',
                  },
                  {
                    title: 'پروتکل‌های پاکسازی',
                    desc: 'با تکنیک‌هایی مانند تراپی آینه و نامه‌های هشت‌گانه، خشم و کینه‌های رسوب‌کرده را تخلیه می‌کنیم. این پاکسازی باعث رهایی از وابستگی‌های سمی شده و آرامش پایداری را بازمی‌گرداند.',
                  },
                  {
                    title: 'جراحی پیشرفته روان',
                    desc: 'با ابزارهای علمی مانند مهندسی معکوس و تکنیک پنج چرا، منافع پنهان دردهای خود را کشف می‌کنید. می‌آموزید چگونه خاطرات تلخ گذشته را در ذهن خود بازنویسی و بی‌اثر کنید.',
                  },
                  {
                    title: 'بازپس‌گیری طلای درون',
                    desc: 'این مرحله پایان نقش قربانی و آغاز آفرینشگری است. شما استعدادها، شجاعت، قدرت و ثروتی را که با برچسب‌های دیگران از شما دزدیده شده بود، پس می‌گیرید و متولد می‌شوید.',
                  },
                  {
                    title: 'تغییر سناریوی گذشته',
                    desc: 'با نفوذ به عمیق‌ترین لایه‌های ذهن، زباله‌های درونی را شخم می‌زنیم. یاد می‌گیرید که چگونه به جای فرار از مشکلات، با آن‌ها روبه‌رو شده و مسیرهای عصبی مغز را تغییر دهید.',
                  },
                  {
                    title: 'آشتی با خودِ واقعی',
                    desc: 'در نفس‌گیرترین بخش کارگاه، بدون نقاب با خود در آینه روبه‌رو می‌شوید. بابت آسیب‌هایی که به روانتان زده‌اید عذرخواهی کرده و قول می‌دهید عزت و قهرمانی را به زندگی برگردانید.',
                  },
                ].map((f) => (
                  <div
                    key={f.title}
                    className="rounded-xl p-3 text-right"
                  >
                    <h3 className="font-black text-gray-900 mb-2" style={{ fontSize: '1.2rem' }}>{f.title}</h3>
                    <p className="leading-7 text-[#616161]" style={{ fontSize: '1rem' }}>{f.desc}</p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* زندگیت دیگه هیچوقت مثل قبل نمیشه */}
      <section className="py-6 bg-gray-50">
        <style>{`
          @keyframes workshopMarquee {
            from { transform: translateX(0); }
            to   { transform: translateX(-50%); }
          }
          .marquee-track {
            animation: workshopMarquee 55s linear infinite;
            will-change: transform;
            user-select: none;
          }
          .no-scrollbar::-webkit-scrollbar { display: none; }
          .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        `}</style>

        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <div className="rounded-xl overflow-hidden text-white" style={{ backgroundColor: '#003399' }}>

            {/* عنوان — وسط */}
            <div className="px-6 lg:px-10 pt-8 pb-6 text-center">
              <h2 className="text-2xl lg:text-3xl font-black">زندگیت دیگه هیچوقت مثل قبل نمیشه</h2>
            </div>

            {/* نوار مارکی پیوسته با درگ — رویداد روی wrapper ثابت */}
            <div
              className="pb-8 px-6 lg:px-10 select-none"
              dir="ltr"
              style={{ cursor: 'grab' }}
              onMouseDown={handleMarqueeMouseDown}
              onMouseEnter={() => {
                if (!dragRef.current.active && marqueeRef.current)
                  marqueeRef.current.style.animationPlayState = 'paused';
              }}
              onMouseLeave={() => {
                if (!dragRef.current.active && marqueeRef.current)
                  marqueeRef.current.style.animationPlayState = 'running';
              }}
            >
              <div
                ref={marqueeRef}
                className="marquee-track flex flex-row w-max"
                onDragStart={e => e.preventDefault()}
              >
                {[...Array(2)].flatMap((_, setIdx) =>
                  Array.from({ length: 24 }, (_, i) => (
                    <div
                      key={`${setIdx}-${i}`}
                      className="flex-shrink-0 rounded-2xl overflow-hidden cursor-pointer"
                      style={{ width: '380px', height: '550px', marginRight: '20px' }}
                      onClick={() => { if (!dragRef.current.moved) setLightbox(i); }}
                    >
                      <img
                        src={`/workshop-gallery/g${i + 1}.jpg`}
                        alt=""
                        className="w-full h-full object-cover pointer-events-none"
                        draggable={false}
                      />
                    </div>
                  ))
                )}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* تحول در چند روز */}
      <section className="py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <div className="bg-white rounded-xl p-6 lg:p-8">

            <h2 className="font-black text-center mb-10 text-gray-900" style={{ fontSize: '1.7rem' }}>
              تحول در چند روز، نه در چند دهه
            </h2>

            {/* تایم‌لاین */}
            <div className="relative mb-8">
              <div
                className="absolute h-0.5 bg-gray-100 rounded-full hidden sm:block"
                style={{ top: '52px', left: '17%', right: '17%' }}
              />
              <div className="grid grid-cols-3 gap-6" dir="rtl">
                {DAYS.map((d, i) => (
                  <div key={d.day} className="flex flex-col items-center gap-3 relative z-10">
                    <span className={`transition-all duration-300 ${
                      hoveredDay === i ? 'text-violet-600 font-black' : 'font-bold text-[#474747]'
                    }`} style={{ fontSize: '1.2rem' }}>{d.day}</span>
                    <div className="relative flex items-center justify-center w-10 h-10">
                      {hoveredDay === i && (
                        <span className="absolute w-10 h-10 rounded-full bg-violet-400 opacity-20 animate-ping" />
                      )}
                      <div className={`relative w-6 h-6 rounded-full border-2 transition-all duration-300 flex items-center justify-center ${
                        hoveredDay === i
                          ? 'border-violet-600 bg-violet-600 scale-110'
                          : 'border-gray-300 bg-white'
                      }`}>
                        {hoveredDay === i && (
                          <div className="w-2 h-2 rounded-full bg-white" />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* کارت‌ها */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" dir="rtl">
              {DAYS.map((d, i) => (
                <div
                  key={d.day}
                  className="rounded-xl overflow-hidden"
                  onMouseEnter={() => setHoveredDay(i)}
                  onMouseLeave={() => setHoveredDay(null)}
                >
                  <div className="w-full overflow-hidden" style={{ aspectRatio: '4/3' }}>
                    <img
                      src={d.image}
                      alt={d.title}
                      className={`w-full h-full object-cover object-top transition-transform duration-500 ${
                        hoveredDay === i ? 'scale-105' : 'scale-100'
                      }`}
                    />
                  </div>
                  <div className="text-right px-1 pt-4">
                    <h3 className="font-black mb-2 text-gray-900" style={{ fontSize: '1.7rem' }}>{d.title}</h3>
                    <p className="text-sm leading-7 text-[#474747]">{d.desc}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* CTA با عکس مدرس */}
      <section className="py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <div className="bg-white rounded-xl p-6 lg:p-8">
            <div className="grid lg:grid-cols-2 gap-8 items-start" dir="ltr">

              {/* عکس - سمت چپ */}
              <div className="relative rounded-2xl overflow-hidden group cursor-pointer" style={{ aspectRatio: '4/3' }} onClick={() => setCtaVideoPlaying(true)}>
                {ctaVideoPlaying ? (
                  <>
                    <iframe
                      src="https://www.aparat.com/video/video/embed/videohash/fcau348/vt/frame?autoplay=1"
                      className="absolute inset-0 w-full h-full border-0"
                      allowFullScreen
                      allow="autoplay; fullscreen"
                    />
                    <button
                      className="absolute top-2 right-2 z-20 w-7 h-7 rounded-full bg-black/60 text-white text-xs flex items-center justify-center hover:bg-black/80 transition"
                      onClick={(e) => { e.stopPropagation(); setCtaVideoPlaying(false); }}
                    >✕</button>
                  </>
                ) : (
                  <>
                    <img src="/workshop-instructor.jpg" alt="استاد فراز غورچیان" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 group-hover:bg-black/55 transition-all duration-300">
                        <svg className="w-5 h-5 text-white translate-x-0.5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* متن - سمت راست */}
              <div className="text-right" dir="rtl">
                <h2 className="text-3xl lg:text-4xl font-black mb-4 text-gray-900">این بار نوبت توست</h2>
                <p className="text-[#474747]" style={{ fontSize: '1.2rem', lineHeight: '1.7rem' }}>
                  شما داستان‌های بی‌نظیر شفای بیماری‌ها، ترک اعتیادهای چندساله، رشد ناگهانی درآمدهای مالی و نجات زندگی‌های زناشویی را در همین صفحه دیدید و شنیدید. هزاران نفر پیش از شما، با کوله‌باری از ناامیدی روی این صندلی‌ها نشستند، اما با شجاعت این مسیر سخت و رهایی‌بخش را طی کردند و همچون ققنوس از میان خاکستر دردهایشان متولد شدند.
                </p>
                <p className="text-[#474747] mt-4" style={{ fontSize: '1.2rem', lineHeight: '1.7rem' }}>
                  اکنون، زمان آن رسیده که شما قهرمان داستان زندگی خود باشید. ذهن شما همواره دلایلی برای به تعویق انداختن تغییر می‌تراشد، اما کائنات امروز شما را برای یک پرش بزرگ آماده کرده است. معجزه زندگی شما، دقیقاً در آن سوی مقاومت‌هایتان منتظر است؛ پس همین حالا برخیزید، زیرا این بار، نوبت درخشش شماست.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* درباره مدرس */}
      <section className="py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">

          {/* دسکتاپ — بنر کامل rahbar */}
          <div className="relative rounded-xl overflow-hidden hidden lg:block">
            <img
              src="/workshop-rahbar-desktop.png"
              alt="استاد فراز قورچیان"
              className="w-full block"
            />
            <div className="absolute inset-y-0 left-0 w-[52%] flex flex-col justify-center px-8 xl:px-12 text-right" dir="rtl">
              <h2 className="text-3xl font-black text-white mb-4 leading-snug">
                راهبر شما در این مسیر کیست؟
              </h2>
              <p className="text-white/85" style={{ fontSize: '1.2rem', lineHeight: '1.7rem' }}>
                استاد فراز قورچیان، ملقب به «پدر ناخودآگاه ایران»، با بیش از دو دهه تجربه میدانی و پژوهش‌های شبانه‌روزی، هدایت این سفر تحول‌آفرین را بر عهده دارند. ایشان تاکنون با برگزاری بیش از ۷۸ دوره موفق کارگاه شفای زخم، مستقیماً با صدها هزار نفر کار کرده و زندگی‌های بی‌شماری را از نقطه‌ی صفر بازسازی کرده‌اند. در رزومه درخشان ایشان، نجات بیش از ۳۵ هزار نفر از تله خودکشی، درمان قطعی ۱۴ هزار مورد افسردگی عمیق و رهایی هزاران نفر از اعتیادهای سنگین به ثبت رسیده است.
              </p>
            </div>
          </div>

          {/* موبایل/تبلت — پس‌زمینهٔ آبی سفارشی + عکس شفاف استاد */}
          <div
            className="lg:hidden rounded-xl overflow-hidden relative"
            style={{ background: 'radial-gradient(130% 100% at 82% 22%, #2f63e8 0%, #1741c6 46%, #0e2f9e 100%)' }}
          >
            <div className="px-5 sm:px-8 pt-7 pb-1 text-right relative z-10" dir="rtl">
              <h2 className="text-2xl sm:text-3xl font-black text-white mb-3 leading-snug">
                راهبر شما در این مسیر کیست؟
              </h2>
              <p className="text-white/85" style={{ fontSize: '1.05rem', lineHeight: '1.7rem' }}>
                استاد فراز قورچیان، ملقب به «پدر ناخودآگاه ایران»، با بیش از دو دهه تجربه و برگزاری بیش از ۷۸ دوره کارگاه شفای زخم، مستقیماً با صدها هزار نفر کار کرده و نجات بیش از ۳۵ هزار نفر از تله خودکشی و درمان ۱۴ هزار مورد افسردگی عمیق را در کارنامه دارند.
              </p>
            </div>
            <img
              src="/workshop-rahbar-instructor.png"
              alt="استاد فراز قورچیان"
              className="w-full object-contain relative z-10 mt-2"
            />
          </div>

        </div>
      </section>

      {/* قیمت و ثبت نام */}
      <section id="register" className="py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <div className="bg-white rounded-xl p-6 lg:p-8">
            <div className="flex flex-col lg:flex-row gap-8 items-start" dir="rtl">

              {/* ستون راست: مزایا */}
              <div className="flex-1 text-right">
                <h3 className="text-2xl lg:text-3xl font-black text-gray-900 mb-6">سفری بی مانند را آغاز کنید</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {[
                    'پشتیبانی ۳۰ روزه',
                    'پذیرایی عالی',
                    'وبینار پرسش و پاسخ',
                    'مشاوره با دستیاران ویژه استاد',
                    'بن تخفیف ۵۰ درصدی خرید محصولات',
                    'عضویت در کانال ویژه شفای زخم',
                    'دریافت چک لیست روزانه',
                    'تست های شخصیت شناسی',
                  ].map((item) => (
                    <div key={item} className="flex items-center gap-2 text-[#474747]">
                      <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center" style={{ backgroundColor: '#7c3aed2b' }}>
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: 'rgb(119 39 255)' }}>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                      </span>
                      <span className="text-sm font-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* ستون چپ: قیمت */}
              <div className="w-full lg:w-64 shrink-0 text-right p-2">
                <h2 className="text-2xl font-black text-[#646464] mb-4">ثبت نام در کارگاه</h2>
                <div className="flex items-baseline gap-2 mb-5" dir="rtl">
                  <p className="font-black text-gray-900" style={{ fontSize: '2.2rem' }}>۳۹/۶۰۰/۰۰۰</p>
                  <p className="text-sm text-[#474747]">تومان</p>
                </div>
                <button
                  type="button"
                  onClick={() => { setRegisterError(''); setIsRegisterModalOpen(true); }}
                  className="flex items-center justify-center gap-2 w-full rounded-xl bg-[#003399] py-3 text-white font-black text-base mb-3 hover:bg-blue-800 active:scale-95 transition"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  ثبت نام
                </button>
                <p className="text-xs text-[#474747] text-center mb-1">جهت مشاوره پیش از ثبت نام تماس بگیرید</p>
                <a href="tel:09363501590" className="flex items-center justify-center gap-1.5 text-sm text-[#003399] font-bold hover:underline" dir="ltr">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  ۰۹۳۶۳۵۰۱۵۹۰
                </a>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* نظرات ویدیویی */}
      <section className="py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <div className="bg-white rounded-xl p-6 lg:p-8">

            {/* هدر */}
            <div className="flex items-center justify-between mb-6" dir="rtl">
              <h2 className="text-2xl lg:text-3xl font-black text-gray-900">ببینید دیگران چه می‌گویند</h2>
              <div className="flex items-center gap-2" dir="ltr">
                <button
                  onClick={() => videoScrollRef.current?.scrollBy({ left: -480, behavior: 'smooth' })}
                  className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button
                  onClick={() => videoScrollRef.current?.scrollBy({ left: 480, behavior: 'smooth' })}
                  className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>

            {/* کارت‌های ویدیو */}
            <div
              ref={videoScrollRef}
              className="flex gap-4 overflow-x-auto pb-2 no-scrollbar"
              dir="rtl"
              style={{ scrollSnapType: 'x mandatory' }}
            >
              {VIDEOS.map((v, i) => (
                <div key={i} className="flex-shrink-0 flex flex-col gap-2" style={{ width: '220px', scrollSnapAlign: 'start' }}>
                  <div
                    className="relative rounded-2xl overflow-hidden"
                    style={{ aspectRatio: '9/16' }}
                    onMouseEnter={() => {
                      if (v.aparat) return;
                      setHoveredVideo(i);
                      const vid = videoRefs.current[i];
                      if (vid) { vid.play().catch(() => {}); }
                    }}
                    onMouseLeave={() => {
                      setHoveredVideo(null);
                      const vid = videoRefs.current[i];
                      if (vid) { vid.pause(); vid.currentTime = 0; }
                    }}
                  >
                    {/* iframe آپارات هنگام پلی */}
                    {playingVideo === i && v.aparat ? (
                      <>
                        <iframe
                          src={`https://www.aparat.com/video/video/embed/videohash/${v.aparat}/vt/frame?autoplay=1`}
                          className="absolute inset-0 w-full h-full border-0"
                          allowFullScreen
                          allow="autoplay; fullscreen"
                        />
                        <button
                          className="absolute top-2 right-2 z-20 w-7 h-7 rounded-full bg-black/60 text-white text-xs flex items-center justify-center hover:bg-black/80 transition"
                          onClick={() => setPlayingVideo(null)}
                        >
                          ✕
                        </button>
                      </>
                    ) : (
                      <>
                        <img
                          src={v.cover}
                          alt={v.title}
                          className={`absolute inset-0 w-full h-full object-cover transition-transform duration-500 ${hoveredVideo === i ? 'scale-105' : 'scale-100'}`}
                        />
                        {v.src && (
                          <video
                            ref={el => { videoRefs.current[i] = el; }}
                            src={v.src}
                            muted
                            loop
                            playsInline
                            preload="metadata"
                            onError={(e) => { (e.target as HTMLVideoElement).style.display = 'none'; }}
                            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${hoveredVideo === i ? 'opacity-100' : 'opacity-0'}`}
                          />
                        )}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                        <div className="absolute bottom-3 right-3 left-3 text-right">
                          <p className="text-white font-black text-sm leading-6">{v.title}</p>
                        </div>
                        {/* دکمه پلی — برای آپارات کلیک‌پذیر، بقیه دکور */}
                        <button
                          className={`absolute inset-0 flex items-center justify-center transition-opacity duration-200 ${v.aparat ? 'cursor-pointer' : 'cursor-default pointer-events-none'} ${hoveredVideo === i ? 'opacity-0' : 'opacity-100'}`}
                          onClick={() => { if (v.aparat) setPlayingVideo(i); }}
                          aria-label="پخش ویدیو"
                        >
                          <div className="w-14 h-14 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-all duration-300">
                            <svg className="w-5 h-5 text-white translate-x-0.5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M8 5v14l11-7z" />
                            </svg>
                          </div>
                        </button>
                      </>
                    )}
                  </div>
                  {/* کپشن زیر کارت */}
                  <p className="text-sm font-bold text-[#474747] text-right leading-6">{v.caption}</p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* سوالات متداول */}
      <section className="py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          <div className="bg-white rounded-xl p-6 lg:p-8">

            {/* هدر */}
            <div className="flex items-center justify-between mb-6" dir="rtl">
              <h2 className="text-2xl lg:text-3xl font-black text-gray-900">سوالات متداول</h2>
              <a
                href="/contact"
                className="text-sm font-bold text-gray-600 border border-gray-200 rounded-xl px-4 py-2 hover:bg-gray-50 transition"
              >
                تماس با ما
              </a>
            </div>

            {/* آکاردئون */}
            <div dir="rtl">
              {faqVisible.map((faq, i) => (
                <div key={faqPage * FAQ_PER_PAGE + i} className={`border-t border-gray-100 ${i === faqVisible.length - 1 ? 'border-b' : ''}`}>
                  <button
                    className="w-full flex items-center justify-between py-4 text-right font-bold text-gray-900 hover:text-violet-600 transition-colors duration-200 gap-4"
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  >
                    <svg
                      className={`w-5 h-5 flex-shrink-0 text-gray-400 transition-transform duration-300 ${openFaq === i ? 'rotate-180 text-violet-500' : ''}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                    <span className="flex-1 text-right">{faq.q}</span>
                  </button>
                  {openFaq === i && (
                    <div className="pb-4 text-right text-[#474747] leading-8 text-sm">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* pagination */}
            <div className="flex items-center justify-center gap-1 mt-6" dir="ltr">
              <button
                onClick={() => { setFaqPage(p => Math.max(0, p - 1)); setOpenFaq(null); }}
                disabled={faqPage === 0}
                className="w-8 h-8 rounded-full flex items-center justify-center text-gray-500 hover:bg-gray-100 disabled:opacity-30 transition"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              {(() => {
                const pages: (number | 'dots')[] = [];
                for (let i = 0; i < faqTotalPages; i++) {
                  if (i === 0 || i === faqTotalPages - 1 || (i >= faqPage - 1 && i <= faqPage + 1)) {
                    pages.push(i);
                  } else if (pages[pages.length - 1] !== 'dots') {
                    pages.push('dots');
                  }
                }
                return pages.map((p, idx) =>
                  p === 'dots' ? (
                    <span key={`dots-${idx}`} className="w-6 h-8 flex items-center justify-center text-gray-400 text-sm select-none">…</span>
                  ) : (
                    <button
                      key={p}
                      onClick={() => { setFaqPage(p); setOpenFaq(null); }}
                      className={`w-8 h-8 rounded-full text-sm font-bold transition ${
                        faqPage === p ? 'bg-violet-600 text-white' : 'text-gray-500 hover:bg-gray-100'
                      }`}
                    >
                      {p + 1}
                    </button>
                  )
                );
              })()}
              <button
                onClick={() => { setFaqPage(p => Math.min(faqTotalPages - 1, p + 1)); setOpenFaq(null); }}
                disabled={faqPage === faqTotalPages - 1}
                className="w-8 h-8 rounded-full flex items-center justify-center text-gray-500 hover:bg-gray-100 disabled:opacity-30 transition"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-5">
          {/* دسکتاپ */}
          <div className="relative rounded-xl overflow-hidden hidden lg:block" style={{ aspectRatio: '3/1' }}>
            {/* عکس پس‌زمینه */}
            <img
              src="/workshop-zakhm-cta.png"
              alt=""
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            {/* برچسب نام - پایین چپ */}
            <div className="absolute bottom-4 left-6 text-white/70 text-xs leading-snug italic tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
              <div>Faraz</div>
              <div>Ghoorchian</div>
            </div>
            {/* متن - سمت راست (فضای آبی خالی) */}
            <div className="absolute inset-y-0 right-0 w-[50%] flex flex-col items-center justify-center gap-4 px-10" dir="rtl">
              <h2 className="text-4xl font-black text-white text-center leading-[3.5rem]">
                باور کن، تو زخم داری
                <br />
                وقتشه که شفاش بدی
              </h2>
              <a
                href="#register"
                className="inline-block rounded-xl border border-white/80 text-white font-black text-xl px-8 py-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 active:scale-95 transition"
              >
                همین حالا سفر قهرمانی‌تان را آغاز کنید
              </a>
            </div>
          </div>

          {/* موبایل/تبلت */}
          <div className="relative rounded-xl overflow-hidden lg:hidden">
            {/* عکس پس‌زمینه موبایل */}
            <img
              src="/workshop-zakhm-cta-mobile.png"
              alt=""
              className="w-full block"
            />
            {/* متن - سمت راست (فضای آبی خالی) */}
            <div className="absolute inset-y-0 right-0 w-[52%] flex flex-col items-center justify-center gap-2 sm:gap-3 px-3 sm:px-6" dir="rtl">
              <h2 className="text-base sm:text-2xl font-black text-white text-center leading-snug">
                باور کن، تو زخم داری
                <br />
                وقتشه که شفاش بدی
              </h2>
              <a
                href="#register"
                className="inline-block rounded-xl border border-white/80 text-white font-black text-[11px] sm:text-base px-3 sm:px-5 py-2 sm:py-2.5 bg-white/10 backdrop-blur-sm hover:bg-white/20 active:scale-95 transition text-center leading-snug"
              >
                همین حالا سفر قهرمانی‌تان را آغاز کنید
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox — بزرگ‌نمایی عکس گالری */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/15 text-white text-lg flex items-center justify-center hover:bg-white/25 transition"
            onClick={(e) => { e.stopPropagation(); setLightbox(null); }}
            aria-label="بستن"
          >✕</button>
          <img
            src={`/workshop-gallery/g${lightbox + 1}.jpg`}
            alt=""
            className="max-w-[92vw] max-h-[90vh] object-contain rounded-xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* مودال ثبت‌نام و پرداخت */}
      {isRegisterModalOpen && (
        <div
          className="fixed inset-0 z-[110] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
          onClick={() => !registerSubmitting && setIsRegisterModalOpen(false)}
        >
          <div
            className="bg-white rounded-2xl p-6 max-w-md w-full"
            dir="rtl"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-xl font-black text-gray-900 mb-1">ثبت نام در کارگاه شفای زخم</h3>
            <p className="text-sm text-[#474747] mb-5">
              مبلغ قابل پرداخت: <span className="font-black text-gray-900">۳۹/۶۰۰/۰۰۰ تومان</span>
            </p>
            <form onSubmit={handleRegisterSubmit}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">نام و نام خانوادگی</label>
                  <input
                    type="text"
                    value={registerForm.customerName}
                    onChange={(e) => setRegisterForm({ ...registerForm, customerName: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003399] focus:border-transparent"
                    disabled={registerSubmitting}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">شماره موبایل</label>
                  <input
                    type="tel"
                    dir="ltr"
                    value={registerForm.customerMobile}
                    onChange={(e) => setRegisterForm({ ...registerForm, customerMobile: e.target.value })}
                    placeholder="09121234567"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003399] focus:border-transparent"
                    disabled={registerSubmitting}
                    required
                  />
                </div>
              </div>

              {registerError && (
                <p className="text-sm text-red-600 mt-3">{registerError}</p>
              )}

              <div className="flex gap-3 mt-6">
                <button
                  type="button"
                  onClick={() => setIsRegisterModalOpen(false)}
                  disabled={registerSubmitting}
                  className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
                >
                  انصراف
                </button>
                <button
                  type="submit"
                  disabled={registerSubmitting}
                  className="flex-1 px-4 py-3 bg-[#003399] text-white font-black rounded-lg hover:bg-blue-800 transition-colors disabled:opacity-50"
                >
                  {registerSubmitting ? 'در حال انتقال به درگاه...' : 'پرداخت و ثبت نام'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
